<template>
    <div class="loader" v-show="this.isLoading"></div> 
    <div class="EnhancedTable Table" v-show="!this.isLoading">
    <div class="SmartBox">
        <div class="SmartBoxText">
            <strong>{{ this.risorse["TabVarTitolo"] }}</strong>
            <span>{{ this.risorse["TabVarSottotitolo"] }}</span>
        </div>
        <div class="SmartBoxForm">
            <div class="Form">
                <div class="FormRow">
                    <div class="FormBox25 FormInputText">
                        <div class="Field"><input type="text" v-model="this.qtyRows" /></div>
                    </div>
                    <div class="FormBox75 FormInputButton">
                        <div class="Field Button Small"><input type="button" :value="this.risorse['TabVarAggiornaSelezione']" @click="this.SetQtyAllRows()" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="this.HaMultipli" class="SmartBox">
        <div class="SmartBoxText">
            <strong>{{ this.risorse["AttenzioneQtaMultipli"] }}</strong>
            <span>{{ this.Multipli }}</span>
        </div>
    </div>
    <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tbody>
            <tr class="TableHead">
                <th scope="col" class="ETProductName">
                    <div class="Form">
                        <div class="FormRow">
                            <div class="FormBoxWide FormCheckBox">
                                <div class="Label">
                                    <span>{{ this.risorse["TabVarNome"] }}</span>
                                </div>
                                <div class="Field"><input type="checkbox" @click="this.clickSelectAll()" :checked="this.selectAll" id="" value=""  /><label for="" class="checkmark"></label></div>
                            </div>
                        </div>
                    </div>
                </th> 
                <th scope="col" class="ETStock">
                    <a href="javascript:void(0)" @click="this.sortByStock()" class="SortingButton"><span> {{ this.risorse["TabVarStock"] }}</span> <img src="/images/SortingIcon.png" srcset="/images/SortingIconRetina.png 2x" alt=""/></a>                    
                </th> 
                <th scope="col" class="ETProductColor"><a href="javascript:void(0)" @click="this.sortByColor()" class="SortingButton"><span>{{ this.risorse["TabVarColore"]}}</span> <img src="/images/SortingIcon.png" srcset="/images/SortingIconRetina.png 2x" alt=""/></a></th> 
                <th scope="col" class="ETProductSize">
                    <a href="javascript:void(0)" @click="this.sortBySize()" class="SortingButton"><span>{{ this.risorse["TabVarTaglia"] }}</span> <img src="/images/SortingIcon.png" srcset="/images/SortingIconRetina.png 2x" alt=""/></a>
                </th> 
                <th scope="col" class="ETProductCode">{{ this.risorse["TabVarCodice"] }}</th> 
                <th scope="col" class="ETUnitPrice">{{ this.risorse["TabVarPrezzoUn"] }}</th> 
                <th scope="col" class="ETQuantity">{{ this.risorse["TabVarQty"] }}</th> 
                <th scope="col" class="ETQuantity">{{ this.risorse["TabVarDtNewArr"] }}</th> 
                <th scope="col" class="ETSubtotal">{{ this.risorse["TabVarSub"] }}</th> 
            </tr>

            <VariantsTableRow
                v-for="(variant, index) in this.variants"
                :key="variant.CodiceArticolo"
                :rowIndex="index+1"
                :variant="variant"
                :limitOrangeSemaphore= "this.limitOrangeSemaphore"
                :isSelectedExt="this.selectAll"
                :qtyRowExt="this.qtyAllRows"
                :isLastRow = "(index == (this.variants.length - 1))"
                @updateTableRows="this.updateTableRowsSelected"
            >
            </VariantsTableRow>
        </tbody>
    </table>
</div>
<!-- Attenzione: l'ultima riga deve esserci! -->
</template>

<script>
import VariantsTableRow from "@/components/VariantsTableRow.vue";
import VariantsService from "@/services/variants.service.js";
import {SogliaArancioneMixin, risorseMixin} from "@/mixin.js";

export default {
    name: "VariantsTable",
    props:{
        idModel: "",
        idCatalog: ""
    },
    components:{
        VariantsTableRow
    },
    data(){
        return {
            variants: [],
            qtyRows: 0,
            sortBySizeAsc: false,
            sortByColorAsc: false,
            sortByNameAsc: false,
            sortByStockAsc: false,
            selectAll: false,
            qtyAllRows: 0,
            isLoading: true
        }
    },
    mixins: [
        SogliaArancioneMixin, risorseMixin
    ],
    methods:{
        updateTableRowsSelected: function(){
            this.selectAll = false;
        },
        clickSelectAll: function(){
            this.selectAll = !this.selectAll;
        },
        SetQtyAllRows: function(){
            this.qtyAllRows = parseInt(this.qtyRows);
            this.qtyRows = 0;
        },
        setData: function(token, idModel){
            VariantsService.getVariantsByModello(token, idModel, this.idCatalog,  this.$store.getters.getLingua).then(
                data => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else{
                        this.variants = data;
                        this.isLoading = false;
                    }
                }
            );
        },
        sortBySize: function(){
            
            this.sortBySizeAsc = !this.sortBySizeAsc;

            if(this.sortBySizeAsc){
                this.variants.sort((a, b) => {
                    if (a.DescrizioneTaglia > b.DescrizioneTaglia) {
                        return 1;
                    }
                    if (a.DescrizioneTaglia < b.DescrizioneTaglia) {
                        return -1;
                    }
                    return 0;
                });
            }
            else{
                this.variants.sort((a, b) => {
                    if (a.DescrizioneTaglia < b.DescrizioneTaglia) {
                        return 1;
                    }
                    if (a.DescrizioneTaglia > b.DescrizioneTaglia) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
        sortByColor: function(){

            this.sortByColorAsc = !this.sortByColorAsc;

            if(this.sortByColorAsc){
                this.variants.sort((a, b) => {
                    if (a.DescrizioneColore > b.DescrizioneColore) {
                        return 1;
                    }
                    if (a.DescrizioneColore < b.DescrizioneColore) {
                        return -1;
                    }
                    return 0;
                });
            }
            else{
                this.variants.sort((a, b) => {
                    if (a.DescrizioneColore < b.DescrizioneColore) {
                        return 1;
                    }
                    if (a.DescrizioneColore > b.DescrizioneColore) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
        sortByStock: function(){

            this.sortByStockAsc = !this.sortByStockAsc;

            if(!this.sortByStockAsc){
                this.variants.sort((a, b) => {
                    if (a.Disponibilita > b.Disponibilita) {
                        return 1;
                    }
                    if (a.Disponibilita < b.Disponibilita) {
                        return -1;
                    }
                    return 0;
                });
            }
            else{
                this.variants.sort((a, b) => {
                    if (a.Disponibilita < b.Disponibilita) {
                        return 1;
                    }
                    if (a.Disponibilita > b.Disponibilita) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
    },
    created: function(){
        this.isLoading = true;
        this.setData(this.$store.getters.getToken, this.idModel);
    },
    watch:{
        idModel: function(newData){
            this.isLoading = true;
            this.setData(this.$store.getters.getToken, this.idModel);
        }
    },
    computed:{
        HaMultipli: function(){
            return  this.variants!= null && this.variants[0]?.Multipli > 1 && this.variants[0]?.VenditaSoloMultipli == true ;
        },
        Multipli: function(){
            return this.risorse["QtaMultipliText"] + this.variants[0]?.Multipli + this.risorse["QtaMultipliText2"];
        }
    }
}
</script>
